module.exports = __webpack_public_path__ + "static/media/slider_1_collab_user_es.75ce1553.svg";